import { BANK_ID_ACCOUNT_SELECTION } from 'Router/routes';
import { FakePageData } from '@4finance/cwt-test-helper';

const accountSelectionScenario: FakePageData = {
  url: BANK_ID_ACCOUNT_SELECTION,
  items: {
    'Select First Account': [
      ['[data-test="account-0"]', 'button'],
      ['[data-test="confirm"]', 'submit-button'],
    ],
  },
};

export { accountSelectionScenario };
